import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { cx } from 'linaria';
import { getVariantsModel, isMainInfoLoading } from 'features/product-info/ducks/selectors';
import { processAxisPoints } from 'features/product-info/components/pdp-variants/utils';
import { addMediaQueryHandlers } from 'utils/add-media-query-handlers';

import type { HTMLAttributes, CommonlyExcludedHTMLAttributeNames } from 'types/utils';

import { variantsAxisContainer } from './styles';
import { PdpVariantAxis } from './variant-axis';
import { PdpVariantDrawerPreview } from './variant-drawer-preview';

type AcceptedHTMLAttributes = Omit<HTMLAttributes, CommonlyExcludedHTMLAttributeNames>;

type VariantsDrawerContentProps = AcceptedHTMLAttributes & {
  onVariantSelect?: (url: string) => void;
};

export const VariantsDrawerContent: React.FC<VariantsDrawerContentProps> = ({
  className,
  onVariantSelect,
  ...htmlProps
}) => {
  const [asOneLine, setAsOneline] = useState(false);

  useEffect(
    () => addMediaQueryHandlers(['screen and (max-width: 1023px)'], [true], false, setAsOneline),
    [],
  );

  const variantsModelContainer = useSelector(getVariantsModel);
  const mainInfoLoading = useSelector(isMainInfoLoading);
  const { variantsModel, activePoint } = variantsModelContainer ?? {};
  const variantAxisCount = variantsModel?.length || 0;

  return (
    <>
      <PdpVariantDrawerPreview />
      {variantsModel?.map((axisModel) => {
        const { axisMeta, pointsOnAxis, asImageThumb } = axisModel;

        const axisPoints = processAxisPoints(pointsOnAxis);

        return (
          <PdpVariantAxis
            className={cx(className, variantsAxisContainer)}
            variantAxisCount={variantAxisCount}
            key={axisMeta.name}
            axisPoints={axisPoints}
            pointKeyGetter={(ap) => ap.toProductUrl}
            activePointKey={activePoint?.productLink}
            axisTitle={axisMeta.name}
            asImageThumb={asImageThumb}
            asOneLine={asOneLine}
            busy={mainInfoLoading}
            onVariantSelect={onVariantSelect}
            {...htmlProps}
          />
        );
      })}
    </>
  );
};
